import { 
    Chip, 
    ExpansionPanel, 
    ExpansionPanelDetails, 
    ExpansionPanelSummary 
} from '@material-ui/core';
import * as React from 'react';
import { OrderHistoryEventType, OrderHistoryEventTypeMetadata } from '../../../models/ordering/enums/order-history-event-type';
import { OrderStatusMetadata } from '../../../models/ordering/enums/order-status';
import {
    LegacyOrderStatusMetadata,
    OrderStatusUpdatedHistoryEvent,
    OrderStatusUpdatedV2HistoryEvent
} from '../../../models/ordering/order-history';
import { AppUtils } from '../../../utils/app-utils';

interface IProps {
    history: any;
    index: number;
}

export const OrderHistoryRow = (props : IProps) => {

    const [expand, setExpand] = React.useState(false);

    const getStatusName = () => {

        // The type of the first kind of event is 0, so test for it being there rather than for it being true
        if (!props.history || props.history.$type === undefined || props.history.$type === null) {
            return 'Unknown Status';
        }
        else if (props.history.$type === OrderHistoryEventType.OrderStatusUpdated) {
            // the events from before the statuses were reworked have a status of the old kind, which has
            // numbers of its own
            const status = LegacyOrderStatusMetadata[(props.history as OrderStatusUpdatedHistoryEvent).status];
            return status ? `Status Update: ${ status.display }` : 'Status Update';
        }
        else if (props.history.$type === OrderHistoryEventType.OrderStatusUpdatedV2) {
            const status = OrderStatusMetadata[(props.history as OrderStatusUpdatedV2HistoryEvent).status];
            return status ? `Status Update: ${ status.display }` : 'Status Update';
        }
        else {
            // the API can write kinds of events that this has not heard of
            return OrderHistoryEventTypeMetadata[props.history.$type as OrderHistoryEventType]?.display ?? 'Unknown Event';
        }

    };

    const getDate = (inputDate : string ) => {
        if(!inputDate) {
            return 'Unknown';
        }
        else {
            const d = new Date(inputDate);
            return d.toUTCString();
        }
    };

    return <ExpansionPanel 
                expanded={expand} 
                classes={{root: "order-history-row", expanded: "order-history-row-expanded"}}
                onChange={ () => setExpand(!expand) }>
                <ExpansionPanelSummary expandIcon={<i className="la la-angle-down"/>}>
                    <Chip classes={{ root: "chipper" }} label={ props.index + 1 } />
                    <div className="history-summary">
                        <span className="summary-type">{ getStatusName() }</span>
                        <span>{ getDate(props.history.timestamp) }</span>
                    </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    {
                        expand
                        ? <div className="row d-block w-100">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <pre 
                                            dangerouslySetInnerHTML={{
                                                __html: AppUtils.colorizeJson(
                                                    props.history
                                                )
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div> : <span/>
                    }                                    
                </ExpansionPanelDetails>
            </ExpansionPanel>;
};
